/*
Number of Comments in story page
domViafoura will be changed by the Viafoura API
This file observes its change and replace our placeholder
*/

import { ComponentBase } from 'utils/abstract-classes/component-base'
import SmoothHashScroll from './smooth-hash-scroll'
import { Nullable } from 'constants/types'

export class StoryComment extends ComponentBase {
    // eslint-disable-next-line no-magic-numbers
    private COMMENTS_THRESHOLD = 5
    private MESSAGE_UNDER = 'Join the conversation'
    private MESSAGE_OVER = 'Comments'

    private get dom(): Nullable<HTMLDivElement> {
        return this.getElement(
            '.article-meta-comment-count__text',
            this.element
        )
    }

    private get domCommentDetail() {
        return (
            this.getElement('.comments__section__list') ||
            document.createElement('')
        )
    }

    public constructor(public element: HTMLElement) {
        super()
        if (!this.dom) {
            return
        }

        this.setIntersectionObserver()
    }

    /*
     * Intersection Observer to trigger replacing when the user saw it
     */
    private setIntersectionObserver() {
        if (!this.dom) {
            return
        }

        // Set IntersectionObserver because MutationObserver does not work when it is not in screen
        const intersectionObserver = new IntersectionObserver(
            (_, observer) => {
                if (!this.dom) {
                    observer.disconnect()
                    return
                }

                // If the element already has the target, mutate it
                if (this.mutate()) {
                    observer.disconnect()
                    return
                }

                this.setMutationObserver()
                observer.disconnect()
            },
            {
                rootMargin: '0px',
                threshold: 1.0
            }
        )
        intersectionObserver.observe(this.dom)
    }

    /*
     * Mutation Observer to trigger replacing when the comment count updated
     */
    private setMutationObserver() {
        if (!this.dom) {
            return
        }

        // Create an observer instance
        const mutationObserver = new MutationObserver(
            (mutationList, observer) => {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                for (const _ of mutationList) {
                    if (this.mutate()) {
                        observer.disconnect()
                        return
                    }
                }
            }
        )

        mutationObserver.observe(this.dom, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
        })
    }

    /*
     * Mutate the target
     */
    private mutate() {
        const target = this.getElement<HTMLSpanElement>(
            '.vf-comments-count',
            this.element
        )
        if (!target) {
            return false
        }

        const exec = RegExp('[0-9]+', 'g').exec(target.innerHTML)
        if (!exec) {
            return false
        }

        const comments = parseInt(exec[0])
        if (!comments) {
            return false
        }

        target.remove()
        if (comments < this.COMMENTS_THRESHOLD) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.dom!.innerHTML = this.MESSAGE_UNDER
        } else {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.dom!.innerHTML = `${comments} ${this.MESSAGE_OVER}`
            this.domCommentDetail.setAttribute('open', 'open')
        }
        return true
    }
}
